var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function orderTooltipPayload(payload, seriesOrder) {
    if (!(seriesOrder === null || seriesOrder === void 0 ? void 0 : seriesOrder.length))
        return payload;
    var indexOf = function (k) {
        var i = seriesOrder.indexOf(k);
        return i === -1 ? seriesOrder.length + 100 : i;
    };
    return __spreadArray([], payload, true).sort(function (a, b) { var _a, _b; return indexOf(String((_a = a.dataKey) !== null && _a !== void 0 ? _a : '')) - indexOf(String((_b = b.dataKey) !== null && _b !== void 0 ? _b : '')); });
}
export function selectSeriesTooltipPayload(row, payload, seriesKeys) {
    var allZero = seriesKeys.every(function (key) { var _a; return Number((_a = row[key]) !== null && _a !== void 0 ? _a : 0) === 0; });
    if (allZero)
        return [];
    return seriesKeys
        .map(function (key) { return payload.find(function (p) { var _a; return String((_a = p.dataKey) !== null && _a !== void 0 ? _a : '') === key; }); })
        .filter(function (p) { return p != null; });
}
